import { GlFilteredSearchToken, GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { JOB_SOURCES } from 'ee_else_ce/ci/common/private/jobs_filtered_search/tokens/constants';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'JobSourceToken',
    JOB_SOURCES,
    components: {
        GlFilteredSearchToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        activeSource () {
            return JOB_SOURCES.find((source)=>source.value === this.value.data) || {};
        }
    }
};
